module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-five.e6c22609.png";